import React from "react";
import * as Sentry from "@sentry/react";
// withTranslation, not the hook: this is a class component, and it renders
// above <I18nextProvider> in App.js — the HOC falls back to the default
// instance registered by lib/i18n and still re-renders on language change.
import { withTranslation } from "react-i18next";

import { logAnalyticsEvent } from "../../utility/FirebaseAnalytics";

import {
  PageBaseHeader,
  PageError,
} from "apps/user/learner/components/page-container";

import { Button } from "components/ui/Button";

import { trackEvent } from "utility/mixpanel";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const userID = localStorage.getItem("userID");
    const companyName = localStorage.getItem("companyName") || "NA";

    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });

    trackEvent("Error Logged", {
      Error: error,
      Message: error.toString(),
      Fatal: "Yes",
    });

    logAnalyticsEvent("exception", {
      user_id: userID,
      user_id_wone: userID,
      company_name: companyName,
      description: error.toString(),
      fatal: true,
    });
  }

  handleReset() {
    window.history.go(0);
  }

  render() {
    const { t } = this.props;
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            textAlign: "center",
          }}
        >
          <PageBaseHeader />
          <PageError>
            <h1>{t("common:error.boundary.title")}</h1>
            <p>{t("common:error.generic.title")}</p>
            <Button variant="primary" onClick={this.handleReset}>
              {t("common:action.tryAgain")}
            </Button>
          </PageError>
        </div>
      );
    }

    return this.props.children;
  }
}

export default withTranslation(["common"])(ErrorBoundary);
